import { useMediaQuery } from '@ag1/ui';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useMemo, useState } from 'react';

type Options = {
  itemsLength: number;
  addSlider: boolean;
};

export function useReviewsSlider({ itemsLength, addSlider }: Options) {
  const atLarge = useMediaQuery('l');
  const atSmall = useMediaQuery('s');

  const active = !!useMemo(
    () =>
      (itemsLength > 1 && addSlider && !atSmall && !atLarge) ||
      (itemsLength > 2 && addSlider && !atLarge) ||
      (itemsLength > 3 && addSlider) ||
      (itemsLength > 3 && !addSlider && atLarge),
    [itemsLength, addSlider, atSmall, atLarge]
  );

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    active,
    slidesToScroll: 1,
    align: 'start',
    // With loop true slider as style issue, when last slide is not visible at the left of first slide
    loop: false,
    containScroll: 'trimSnaps'
  });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
  }, [emblaApi, onSelect]);

  return {
    ref: emblaRef,
    active,
    scrollPrev: canScrollPrev && emblaApi!.scrollPrev,
    scrollNext: canScrollNext && emblaApi!.scrollNext
  };
}
